module.exports = __webpack_public_path__ + "static/img/03.bb3f460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/03.jpg
// module id = +BSi
// module chunks = 0